import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { productActivationApiNames, productActivationProducts } from 'ui-addon-upgrades/_core/common/constants/productActivation';
import devLogger from 'react-utils/devLogger';

const ProductActivationWrapper = WrappedComponent => {
  const ProductActivationWrapperHOC = props => {
    const {
      upgradeData: {
        upgradeProduct,
        apiName
      },
      canViewNewSeats
    } = props;
    let isProductActivationWrapperProduct;

    if (canViewNewSeats && apiName) {
      isProductActivationWrapperProduct = productActivationApiNames.includes(apiName);
    } else {
      isProductActivationWrapperProduct = productActivationProducts.includes(upgradeProduct);
    }

    if (!isProductActivationWrapperProduct) {
      devLogger.warn({
        message: `ProductActivationWrapper: Expected upgradeProduct to be one of ${productActivationProducts}`,
        key: 'ProductActivationWrapper'
      });
      return null;
    }

    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };

  return ProductActivationWrapperHOC;
};

export default ProductActivationWrapper;